import { type FunctionComponentElement } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { getElement } from 'src/utils/get-element';

const rootsMap = new WeakMap<Element, Root>();

export const renderToDecorator = (
  selector: string,
  component: FunctionComponentElement<any>
) => {
  const element = getElement(selector);

  if (!element) return;

  let root = rootsMap.get(element);
  if (!root) {
    root = createRoot(element);
    rootsMap.set(element, root);
  }
  root.render(component);
};
